module.exports = __webpack_public_path__ + "static/media/team_2.88e2e088.jpg";